// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__nf8Fa","signatureButtonsRight":"ModalSign_signatureButtonsRight__oVJp-"};